import React, {useState} from 'react';
import './GalleryWidget.css';
import {Col, Row} from "react-bootstrap";

const GalleryWidget = ({images}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);

    const openModal = (index) => {
        setCurrentIndex(index);
        setIsModalOpen(true);
    };

    const closeModal = () => setIsModalOpen(false);

    const nextImage = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    };

    const prevImage = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? images.length - 1 : prevIndex - 1
        );
    };

    return (
        <Row>
            {/* Thumbnails */}
            {images && images.map((image, index) => (
                <Col xs={12} md={4} lg={2} key={index} className="gallery-thumbnails">
                    <img
                        src={`${process.env.REACT_APP_SERVER_URL}${image.variations.gallery_thumb}`}
                        alt={image.name}
                        className="thumbnail"
                        onClick={() => openModal(index)}
                    />
                    <div className="overlay">
                        <a href={`/images/${image.id}/edit`} className="pencil-link">edit</a>
                    </div>
                </Col>
            ))}


            {/* Modal */}
            {isModalOpen && (
                <div className="modal-overlay" onClick={closeModal}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <button className="close-button" onClick={closeModal}>×</button>
                        <div className="modal-image-container">
                            <button className="prev-button" onClick={prevImage}>‹</button>
                            <button className="next-button" onClick={nextImage}>›</button>
                            <div className="image-label">{images[currentIndex].caption}</div>
                            <img
                                src={`${process.env.REACT_APP_SERVER_URL}${images[currentIndex].variations.full}`}
                                alt={images[currentIndex].altText}
                                className="full-image"
                            />
                        </div>
                    </div>
                </div>
            )}
        </Row>
    );
};

export default GalleryWidget;